export enum Types {
  POST = "PLANNING_IMPORT_POST",
  POST_SUCCESS = "PLANNING_IMPORT_POST_SUCCESS",
  POST_FAIL = "PLANNING_IMPORT_POST_FAIL",
}

export type Action = PostTemplateImportAction | PostTemplateImportSuccessAction | PostTemplateImportFailAction

export type PostTemplateImportAction = {
  type: Types.POST
}

export type PostTemplateImportSuccessAction = {
  type: Types.POST_SUCCESS
}

export type PostTemplateImportFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export function postTemplateImport(): PostTemplateImportAction {
  return {
    type: Types.POST,
  }
}

export function postTemplateImportSuccess(): PostTemplateImportSuccessAction {
  return {
    type: Types.POST_SUCCESS,
  }
}

export function postTemplateImportFail(errors: object): PostTemplateImportFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}
